import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { setupAxios } from './utils/axios';
import { store } from './app/store';
import { Provider } from 'react-redux';
import { ThemeProvider } from './theme-context';
import { clearApiRegion } from './config';


setupAxios();

// Bridge auth from the host page into this iframe.
// This is required because localStorage is origin-scoped, so the host token
// cannot be read directly from within the iframe.
if (typeof window !== 'undefined') {
	window.addEventListener('message', (event) => {
		const data = event?.data;
		if (!data || (data.type !== 'hotelworld-auth' && data.type !== 'hotelworld-theme')) return;

		if (typeof data.theme === 'string' && (data.theme === 'dark' || data.theme === 'light')) {
			localStorage.setItem('theme', data.theme);
			document.documentElement.classList.toggle('dark', data.theme === 'dark');
			window.dispatchEvent(new Event('hotelworld-theme-change'));
		}

		if (data.type !== 'hotelworld-auth') return;

		try {
			if (typeof data.accessToken === 'string' && data.accessToken) {
				const existing = localStorage.getItem('accessToken');
				if (!existing || existing !== data.accessToken) {
					clearApiRegion();
				}
				localStorage.setItem('accessToken', data.accessToken);
				// Marker for debugging: verify the iframe received auth.
				localStorage.setItem(
					'__HW_AUTH_RECEIVED_AT__',
					JSON.stringify({ receivedAt: Date.now(), existingSame: existing === data.accessToken }),
				);

				// Avoid reload loops: reload only if token was missing or different.
				if (existing && existing === data.accessToken) {
					console.log('[hotelworld] auth message received (token unchanged)');
					return;
				}
			}
			if (typeof data.refreshToken === 'string') {
				localStorage.setItem('refreshToken', data.refreshToken);
			}
			if (typeof data.roles === 'string' && data.roles) {
				localStorage.setItem('roles', data.roles);
			}
			if (typeof data.user === 'string' && data.user) {
				localStorage.setItem('user', data.user);
			}
			if (typeof data.cgToken === 'string' && data.cgToken) {
				localStorage.setItem('cgToken', data.cgToken);
			}

			console.log('[hotelworld] auth message received, reloading iframe...');

			// Reload so route guards re-evaluate with the injected token.
			window.location.reload();
		} catch {
			// noop
		}
	});
}

const root = ReactDOM.createRoot(document.getElementById('root') as Element);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <Provider store={store}>
                <ThemeProvider>
                    <App />
                </ThemeProvider>
            </Provider>
        </BrowserRouter>
    </React.StrictMode>,
);
